/**
 * DOM toast dock — replaces the old canvas-rendered toast queue. Toasts
 * stack bottom-right, auto-dismiss, and never trap focus.
 */

const TOAST_MS = 4200;
const MAX_STACK = 3;

export type ToastKind = 'info' | 'success' | 'error';

export function pushToast(text: string, kind: ToastKind = 'info'): void {
  const dock = document.getElementById('toast-dock');
  if (!(dock instanceof HTMLElement)) return;

  const el = document.createElement('div');
  el.className = `toast toast--${kind}`;
  el.setAttribute('role', 'status');
  el.textContent = text;
  dock.appendChild(el);

  while (dock.children.length > MAX_STACK) {
    dock.firstChild?.remove();
  }

  window.setTimeout(() => {
    el.classList.add('toast--out');
    window.setTimeout(() => el.remove(), 400);
  }, TOAST_MS);
}
